<template>
  <div class="container f-bg-height-col-7">
    <v-stepper
        v-model="step"
        alt-labels
      >
      <div class="row u-justify-content-lg-flex-end">
        <div class="col-12 col-lg-7 u-order-2 u-order-lg-1 full-height-bg">
          <SystemOverview
            :go-back="goBack"
            :open-image="openImage"
            :manual="false"
            :coldroom="$store.getters.coldroom"
            :coldroomsystem="$store.getters.coldroomSystem"
            :cutoutwidth="$store.getters.cutOutWidth"
            :cutoutheight="$store.getters.cutOutHeight"
            :suggestedheight="$store.getters.suggestedHeight"
            :color="$store.getters.color"
            :shelving="this.$store.state.shelvingsSwitch"
            >
          </SystemOverview>
        </div>
        <div class="col-12 col-lg-5 u-order-1 u-order-lg-2 configuration-stepper">
          <v-stepper-header>
            <v-stepper-step complete step="1">{{ $t('coldroom.select') }}</v-stepper-step>
            <v-divider class="complete"></v-divider>
            <v-stepper-step complete step="2">{{ $t('system.select') }}</v-stepper-step>
            <v-divider class="complete"></v-divider>
            <v-stepper-step complete step="3">{{ $t('size_design') }}</v-stepper-step>
            <v-divider class="complete"></v-divider>
            <v-stepper-step complete step="4">{{ $t('configurator.label') }} </v-stepper-step>
            <v-divider class="complete"></v-divider>
            <v-stepper-step step="5">{{ $t('configurator.results.your_result') }}</v-stepper-step>
          </v-stepper-header>
        </div>
        <div class="col-12 col-lg-5 u-order-3">
          <div class="results">
            <v-stepper-items>
              <v-stepper-content step="5">
                <div v-if="$store.getters.suggestedHeight > 0">
                  <div>
                    <h2>{{ $t('configurator.results.your_result') }}</h2>
                    <div class="results__label u-font-weight-700 u-text-transform-uppercase">{{ $t('configurator.results.base_on_selection') }}</div>
                    <table class="system_resume">
                      <tr>
                        <td>{{ $t('coldroom.label') }}:</td>
                        <th>{{ systemType }}</th>
                      </tr>
                      <tr>
                        <td>{{ $t('system.label') }}:</td>
                        <th>{{ $t('system.' + $store.getters.coldroomSystem + '.label')}}</th>
                      </tr>
                      <tr>
                        <td>{{ $t('configurator.results.installation_width') }}:</td>
                        <th>{{ this.$store.state.bestSystem.width }}</th>
                      </tr>
                      <tr>
                        <td>{{ $t('configurator.results.installation_height') }}:</td>
                        <th v-if="['view','tview'].includes($store.getters.coldroomSystem) && [2046, 2053].includes($store.getters.suggestedHeight)">1846</th>
                        <th v-else>{{ $store.getters.suggestedHeight }}</th>
                      </tr>
                      <tr>
                        <td>{{ $t('configurator.colors.label') }}:</td>
                        <th>{{ $store.getters.color }}</th>
                      </tr>
                      <tr>
                        <td>{{ $t('configurator.shelvings.label') }}:</td>
                        <th>{{ shelves }}</th>
                      </tr>
                      <tr>
                        <td>{{ $t('configurator.results.doors_number') }}:</td>
                        <th>{{ this.$store.state.numberOfDoors }}</th>
                      </tr>
                      <tr>
                        <td>{{ $t('configurator.results.systems_number') }}:</td>
                        <th>{{numberOfSystems}}</th>
                      </tr>
                    </table>
                  </div>
                  <div>
                    <div class="u-justify-content-space-between u-align-items-center">
                      <div class="u-display-flex u-align-items-center u-justify-content-space-between">
                        <div class="configurator__label">{{ $t('configurator.results.chosen_systems') }}</div>
                        <button @click="stepBefore" class="btn btn--ghost-primary icon icon--right u-margin-top-0">
                          {{ label }} <i class="icon-edit"></i>
                        </button>
                      </div>
                    </div>
                    <table v-if="isMobile && $store.getters.bestSystem.components" class="choosen-results">
                      <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name_and_article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                      </thead>
                      <tbody>
                        <tr v-for="(system, index) in $store.getters.bestSystem.components" v-bind:key="index">
                          <td>
                            <span class="u-display-block"><small>{{ system['Article number'] }}</small></span>
                            <span class="u-display-block">{{ system.Description }}</span>
                          </td>
                          <td>{{ system.amount}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table v-if="!isMobile && $store.getters.bestSystem.components" class="choosen-results">
                      <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                      </thead>
                      <tbody>
                        <tr v-for="(system, index) in $store.getters.bestSystem.components" v-bind:key="index">
                          <td>{{ system.Description }}</td>
                          <td>{{ system['Article number'] }}</td>
                          <td>{{ system.amount}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <Accessoires
                      :systems="$store.getters.bestSystem.components" :label="label" :key="accessoiresKey"
                    ></Accessoires>
                  </div>
                  <div>
                    <RequestQuotation
                      :systems="$store.getters.bestSystem.components"
                      :accessoires="$store.getters.computedAccessoires"
                    ></RequestQuotation>
                  </div>
                </div>
                <div v-else>
                  <div class="no-results">
                    <h2>{{ $t('configurator.results.your_result') }}</h2>
                    <div class="results__label u-font-weight-700 u-text-transform-uppercase">{{ $t('configurator.results.base_on_selection') }}</div>
                    <span class="u-display-block">{{ $t('configurator.results.empty_results')}}</span>
                    <button @click="goBack" class="btn btn--primary">
                      {{ $t('configurator.results.select_new_size_design')}}
                    </button>
                    </div>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </div>
        </div>
      </div>
    </v-stepper>
  </div>
</template>

<style lang="scss" scoped>
@import './../sass/main.scss';
.configuration-stepper {
  @include media-breakpoint-up(lg) {
    position: absolute;
    height: rem(100);
  }
}
h2 {
  @include media-breakpoint-up(md) {
    @include gutter(margin-top, xxl);
  }
}
.u-order-3 {

  @include media-breakpoint-up(lg) {
    padding-top: rem(100);
  }
}
table.system_resume {
  @include gutter(margin-top, xs);
  th {
    @include gutter(padding-left, md);
  }
  th,
  td {
    @extend .u-vertical-align-top;
  }
}
.no-results {
  @include gutter(margin-top, lg);
  @include gutter(margin-bottom, xs);
}
</style>

<script>
import specData from "@/assets/WidthSpecifications_New_New.json";
import Accessoires from "./Accessoires.vue";
import RequestQuotation from "./RequestQuotation.vue";
import jsonQ from "jsonq";
import SystemOverview from "./SystemOverview.vue";
import TrackingHelper from "../helpers/TrackingHelper";

export default {
  components: {
    Accessoires,
    RequestQuotation,
    SystemOverview,
  },
  data: function() {
    return {
      step: 5,
      isMobile: false,
      label: "Edit",
      specDataParser: jsonQ(
        specData[this.$store.state.coldroom][this.$store.state.coldroomSystem][
          this.$store.state.color
        ][this.$store.state.suggestedHeight]
      ),
      color: this.$store.state.color,
      shelvings: this.$store.state.shelvingsSwitch,
      accessoiresKey: 0
    };
  },
  beforeDestroy () {
    if (typeof window === 'undefined')  {
      return window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted () {
    this.trackVirtualPageview();
    /* eslint-disable no-console */
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
    this.$store.commit("setShelvesPerDoor", 5);
    this.$store.commit("setShelvesWirePlate", "wire");
    this.$store.commit("setPostsFrontBack", "back");
    this.$store.commit("setGravitySheetSwitch", false);
    if (this.$store.state.coldroomSystem == "classic") {
      this.$store.commit("setShelvesSingleDouble", "single");
    } else {
      this.$store.commit("setShelvesSingleDouble", "double");
    }
    this.$store.commit("setContainerStops", false);
    this.$store.commit("setFrontStopsPerShelf", 6);
    this.$store.commit("setDividersPerShelf", 5);
    if (this.$store.state.coldroomSystem == "classic") {
      this.$store.commit("setKitFlanges", 0);
      this.$store.commit("setArticle", "76");
    } else {
      this.$store.commit("setKitFlanges", 1);
      this.$store.commit("setArticle", "66");
    }
    //// Best system
    // Trick to make store readable in mount
    const { getters } = this.$store;
    // Calculate best system
    let fittingSystems = this.specDataParser
      .find("width", function() {
        return this <= getters.cutOutWidth;
      })
      .parent();
    let maxNumberOfDoors = Math.max(...fittingSystems.find("doors").value());
    let systemsWithMaxNumberOfDoors = fittingSystems
      .find("doors", function() {
        return this == maxNumberOfDoors;
      })
      .parent();
    let minNumberOfFrames = Math.min(
      ...systemsWithMaxNumberOfDoors.find("frames").value()
    );
    let bestSystem = systemsWithMaxNumberOfDoors
      .find("frames", function() {
        return this == minNumberOfFrames;
      })
      .parent()
      .value()[0];
    this.$store.commit("setBestSystem", bestSystem);

  },
  beforeUpdate () {
    this.forceRerender()
  },
  computed: {
    convertBestSystemToString: {
      get() {
        const arrayOfArticles = this.$store.state.bestSystem.components.map(x => (x['Article number'] + ',').repeat(x['amount']));
        return arrayOfArticles.join("").slice(0,-1);
      }
    },
    convertPlateWireToBooleanString: {
      get() {
        if (this.$store.state.shelvesWirePlate == 'plate'){
          return "false"
        }
        else {return "true"}
      }
    },
    convertShelvingsSwitchToString: {
      get() {
        if (this.$store.state.shelvingsSwitch){
          return "true"
        }
        else {
          return "false"
        }
      }
    },
    convertSingleDoubleToString: {
      get() {
        if (this.$store.state.shelvesSingleDouble == "double") {
          return "true";
        } else {
          return "false";
        }
      },
    },
    convertGravitySheetsToString: {
      get() {
        if (this.$store.state.gravitySheetSwitch) {
          return "true";
        } else {
          return "false";
        }
      },
    },
    convertContainerStopsToString: {
      get() {
        if (this.$store.state.containerStops) {
          return "true";
        } else {
          return "false";
        }
      },
    },
    numberOfSystems: {
      get() {
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue["amount"];
        let numberOfSystems = this.$store.state.bestSystem.components.reduce(
          reducer,
          0
        );
        this.$store.commit("setNumberOfSystems", numberOfSystems);
        return numberOfSystems;
      },
    },
    kitFlanges: {
      get() {
        return this.$store.state.kitFlanges;
      },
      set(value) {
        let i = value ? 1 : 0;
        this.$store.commit("setKitFlanges", i);
      },
    },
    systemType: {
      get () {
        if (this.$store.getters.coldroom === "NT") {
          return "Normal Temperature";
        } else {
          return "Low Temperature";
        }
      }
    },
    shelves: {
      get () {
        if (this.shelvings) {
          return "Yes";
        } else {
          return "No";
        }
      }
    },
  },
  methods: {
    trackVirtualPageview () {
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.virtualPageview('Best Setup Results');
    },
    goBack () {
      this.$router.push({
        name: "First Steps",
        params: {
          step: 3,
          isThirdStep: true,
          systemName: this.$store.getters.coldroomSystem
        }
      });
    },
    stepBefore () {
      this.$router.push({
        name: "Manual Configurator",
        params: {
          step: 4,
          systemName: this.$store.getters.coldroomSystem,
          selectedSerie: this.$store.getters.bestSystem.components[0].Subseries
        }
      });
    },
    onResize () {
      this.isMobile = window.innerWidth < 720
    },
    openImage () {
      let routeData = '../../Schott20211206/?front_back=' +
                    this.$store.state.postsFrontBack +
                    '&wired=' +
                    this.convertPlateWireToBooleanString +
                    '&systems=' +
                    this.convertBestSystemToString + '&shelvescount=' + this.$store.state.shelvesPerDoor +
                    '&doubleshelves=' + this.convertSingleDoubleToString +
                    '&sheets=' + this.convertGravitySheetsToString +
                    '&stops=' + this.convertContainerStopsToString +
                    '&shelves=' + this.convertShelvingsSwitchToString
      window.open(routeData, '_blank');
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.clickTracking('button', 'view results in 3d');
    },
    forceRerender() {
      this.accessoiresKey += 1;
    }
  }
}
</script>
